
<!-- breadcrumb - in inner listing only - desktop screens-->
<div *ngIf="!isHomepage" class="page-header">
  <div class="container">
    <lib-breadcrumb [breadcrumbs]="_service.config.breadcrumbs"></lib-breadcrumb>
  </div>
</div>

<section class="d-lg-block services-listing {{isHomepage ? 'services-listing d-none' : ''}}">
  <div [ngClass]="{ container: !isHomepage }">
    <div [ngClass]="{' rounded services-list   border-0': !isHomepage}">
      <form (ngSubmit)="submit()" #formRef #form="ngForm" class="d-none d-lg-block" *ngIf="!isMobile">
        <div  class=" {{!isHomepage ?'w-100' :'container'}}">
          <div class="d-flex justify-content-between align-items-center service-catalog">
            <div>
              <h2 class="home-title">
                {{ translationData.serviceCatalog || "Service Catolgue" }}
              </h2>
            </div>
            <div class="sort">
              <app-select-box #sortDir [hasClear]="false" name="sortDir" [showSelectOption]="false"
                [(ngModel)]="model.sortDir" placeholder="{{ translationData?.sortBy || 'Sort By' }}" (onChange)="sort()"
                valueProperty="uniqueKey" displayProperty="displayName" [items]="sortDirList">
              </app-select-box>
            </div>


          </div>
          <div class="form-row ">
            <div class="col-lg-3">
              <div class="d-flex flex-column side-filter">

                <div class=" search-control">
                  <div class="d-flex justify-content-between align-items-stretch">
                    <app-text-box id="searchKeyword" name="searchKeyword"
                      placeholder="{{translationData?.searchServices || 'Search Services' }}"
                      [(ngModel)]="model.searchKeyword" #searchKeyword="ngModel" type="text" [maxLength]="50"
                      class="w-100">
                    </app-text-box>
                    <button 
                    aria-label="icon-search"
                     class="btn btn-primary search-button" type="submit">
                      <span class="icon-search"></span>
                    </button>
                  </div>


                </div>

                <div>

                  <label class="service-category-label">{{ translationData?.userType || 'User Type' }}</label>
                  <div class="category-container">
                    <div class="d-flex service-category-container " *ngFor="let item of userTypeList ;trackBy: trackByIndex">
                      <label title="undefined" for="undefined"></label>
                      <input type="checkbox" class="service-category-input" name="userType" #userType="ngModel"
                        [value]="item.id" [(ngModel)]="item.selected" (change)="onUserTypeChange($event, item)">
                      {{ item.displayName }}
                    </div>
                  </div>
                </div>


                <div *ngIf="ServiceCategoryList && ServiceCategoryList.length > 1">
                  <label class="service-category-label">{{ translationData?.serviceCategory || 'Service Category'
                    }}</label>
                  <div class="category-container">
                    <div class="d-flex service-category-container " *ngFor="let item of ServiceCategoryList ;trackBy: trackByIndex">
                      <label title="undefined" for="undefined"></label>
                      <input type="checkbox" class="service-category-input" name="serviceType" #serviceType="ngModel"
                        [value]="item.id" [(ngModel)]="item.selected" (change)="onMultiSelectValueChange($event, item)">
                      <span class="service-category-value">{{ item.displayName }}</span>
                    </div>
                  </div>

                </div>

              </div>

            </div>
            <div class="col-lg-9">

              <div class="row">

                <!-- start of card component -->
                <div *ngFor="let service of serviceList ;trackBy: trackByIndex" class="col-md-6 col-lg-4 d-flex services-lg  ">
                  <div class="service-catalog-card flex-grow-1 ">
                    <div class="service-card text-decoration-none" title="">
                      <div class="d-flex justify-content-between align-items-start">
                        <div class="service-img">
                          <a  aria-label="service Details Route" title="service Details Route" href="{{ baseURL? baseURL +'/'+ serviceDetailsRoute + service.id : serviceDetailsRoute + '/' + service.id }}" class="text-decoration-none">
                              <img loading="lazy" *ngIf="!service.image" src="../../assets/images/service-catalog.svg" [alt]="service.serviceName" /> 
                              <img loading="lazy" *ngIf="service.image" [src]="getImageSrc(service.image)" [alt]="service.serviceName" />
                          </a>
                        </div>

                        <div class="sharer position-relative">
                          <button 
                          class="sharer-btn p-0 border-0 position-relative" type="button"
                            role="button" [title]="translationData.share" >
                            <span class="icon-share">
                            </span>
                          </button>
                          <div class="sharer-links position-absolute">
                            <ul class="list-unstyled d-flex justify-content-center align-items-center h-100">
                              <li>
                                <a href="https://www.facebook.com/sharer/sharer.php?u={{baseuRL+'/%23/services/service-details/' + service.id}}&amp;src=sdkpreparse"
                                  class="d-flex align-items-center" target="_blank" [title]="translationData.facebook"
                                  >
                                  <span class="icon-facebook icon-social"></span>
                                </a>
                              </li>
                              <li>
                                <a href="http://twitter.com/share?text=&url={{baseuRL+'/%23/services/service-details/' + service.id}}&hashtags"
                                  class="d-flex align-items-center" target="_blank" [title]="translationData.twitter"
                                  >
                                  <span class="icon-twitter icon-social"></span>
                                </a>
                              </li>
                              <li>
                                <a href="https://www.linkedin.com/sharing/share-offsite/?url={{baseuRL+'/%23/services/service-details/' + service.id}}"
                                  class="d-flex align-items-center" target="_blank" [title]="translationData.linkedin"
                                  >
                                  <span class="icon-linkedin-2 icon-social"></span>
                                </a>
                              </li>
                              <li>
                                <a href="https://wa.me/?text={{ baseuRL+'/%23/services/service-details/' + service.id}}"
                                  data-action="share/whatsapp/share" class="d-flex align-items-center" target="_blank"
                                  [title]="translationData.whatsapp" >
                                  <span class="icon-whatsapp icon-social"></span>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>


                      </div>

                      <div class="service-body rounded ">
                        <!-- <span class="content">
                            {{ getServiceCategoryPerModule(service.categoriesIds) }}
                          </span> -->
                        <h3 [title]="service.serviceName" class="service-title">
                          <a class="text-decoration-none"
                          aria-label="service Details Route" [title]="service.serviceName"
                            href="{{ baseURL? baseURL +'/'+ serviceDetailsRoute + service.id : serviceDetailsRoute + '/' + service.id }}">{{ service.serviceName }}</a>
                        </h3>
                        <a  aria-label="service Details Route" [title]="stripHtml(service.description)"
                        href="{{ baseURL? baseURL +'/'+ serviceDetailsRoute + service.id : serviceDetailsRoute + '/' + service.id }}"
                          class="service-brief text-decoration-none"
                          [innerHTML]="service.description | safe: 'html'"></a>
                        <a  aria-label="service Details Route" [title]="translationData.serviceDetails || 'Service Details'"
                        href="{{ baseURL? baseURL +'/'+ serviceDetailsRoute + service.id : serviceDetailsRoute + '/' + service.id }}"
                          class="service-link link-btn">
                          {{ translationData.serviceDetails || "Service Details" }}
                          <span class="icon-flat-arrow-right"></span>
                        </a>
                      </div>
                    </div>
                  </div>

                </div>
                <!-- end of card component -->

              </div>
              <a aria-label="service Details Route" title="service Details Route"
              href="{{ baseURL? baseURL+serviceCardsRoute : serviceCardsRoute }}"
                *ngIf="isHomepage && totalCount > pageSize" class="btn btn-primary mx-auto my-4 d-table view-btn ">
                {{ translationData?.viewAll || "View all" }}
              </a>
              <div *ngIf="serviceList && serviceList.length == 0" class="no-results-msg">
                <p><span class="icon-search"></span></p>
                <p>{{ translationData?.noResultMsg || "No Results Found" }}</p>
              </div>
              <div class="row">
                <lib-pager [first]="start" *ngIf="!isHomepage && totalCount > pageSize" class="my-5 d-block m-auto py-3"
                  (pageChange)="pageChange($event)" pageLinkSize="5" [rows]="pageSize" [totalRecords]="totalCount">
                </lib-pager>
              </div>

            </div>



          </div>
        </div>
      </form>


    </div>
  </div>
</section>
<section  class="container d-lg-none mt-5">
  <div class="form-row">
    <div class="col-8">
      <div>
        <form name="mobileSearchForm">
          <div class="position-relative  d-flex search-responsive">
            <button aria-label="icon-search" (click)="submit()" type="submit" class="no-underline">
              <span class="icon-search"></span>
            </button>
            <label title="undefined" for="undefined"></label>
            <input type="text" id="searchKeywordMobile" name="searchKeyword"
              placeholder="{{translationData?.searchServices || 'Search Services'}}" [(ngModel)]="model.searchKeyword"
              #searchKeyword="ngModel" type="text" [maxLength]="50" />

          </div>
        </form>
      </div>
    </div>
    <div class="col-4">
      <form ngForm #mobileSearchFilter="ngForm" name="mobileSearchFilter" class="form-row h-100">
        <div class="w-50 container-filter">
          <button #offcanvasButtonTop class="btn filter-btn w-100 d-flex justify-content-center align-items-center h-100" type="button"
          data-bs-toggle="offcanvas" aria-label="offcanvas Top" data-bs-target="#offcanvasTop" aria-controls="offcanvasTop">
    <span class="icon-filters filter-icon"></span>
  </button>
  
  <div #offcanvasDivTop class="offcanvas offcanvas-bottom" tabindex="-1" id="offcanvasTop" aria-labelledby="offcanvasTopLabel">
    <div class="offcanvas-header">
      <h5 class="head-offcanvas filter-head" id="offcanvasTopLabel">{{translationData.filter || "Filter"}}</h5>
      <button #closeButtonTop type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"
              (click)="offcanvasClearFilter()"></button>
    </div>
    <div class="offcanvas-body">
      <div>
        <label class="service-category-label">{{ translationData?.userType || 'User Type' }}</label>
        <div class="category-container">
          <div class="d-flex service-category-container" *ngFor="let item of userTypeList;trackBy: trackByIndex">
            <label title="undefined" for="undefined"></label>
            <input type="checkbox" class="service-category-input" name="userType" #userType="ngModel"
                   [value]="item.id" [(ngModel)]="item.selected" (change)="onUserTypeResponsive($event, item)">
            {{ item.displayName }}
          </div>
        </div>
      </div>
      <div>
        <label class="service-category-label">{{ translationData?.serviceCategory || 'Service Category' }}</label>
        <div class="category-container offcanvas-category-container">
          <div class="d-flex service-category-container" *ngFor="let item of ServiceCategoryList ;trackBy: trackByIndex">
            <label title="undefined" for="undefined"></label>
            <input type="checkbox" class="service-category-input" name="serviceType" #serviceType="ngModel"
                   [value]="item.id" [(ngModel)]="item.selected" (change)="onMultiSelectValueChangeResponsive($event, item)">
            <span class="service-category-value">{{ item.displayName }}</span>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-between">
        <button data-bs-dismiss="offcanvas" aria-label="Close" (click)="apply()"
                class="btn btn-primary filter-sort-btn" type="submit">
          <span class="icon-off-filter sort-icon"></span>
          <span class="sort-text">{{translationData.filter || "Filter"}}</span>
        </button>
        <button data-bs-dismiss="offcanvas" aria-label="Close" (click)="onClearFilters()" class="btn clear-btn"
                type="button">{{ translationData?.clearFilters || "Clear" }}</button>
      </div>
    </div>
  </div>
  
  
        </div>
        <div class="w-50 container-sort">
          <button #offcanvasButtonSort aria-label="offcanvas Sort" class="btn filter-btn w-100 d-flex justify-content-center align-items-center h-100" type="button"
          data-bs-toggle="offcanvas" data-bs-target="#offcanvasSort" aria-controls="offcanvasSort">
    <span class="icon-sort filter-icon"></span>
  </button>
  
  <div #offcanvasDivSort class="offcanvas offcanvas-bottom" tabindex="-1" id="offcanvasSort" aria-labelledby="offcanvasTopLabel2">
    <div class="offcanvas-header">
      <h5 class="head-offcanvas" id="offcanvasTopLabel">{{translationData.sort || "Sort"}}</h5>
      <button #closeButtonSort type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"
              (click)="offcanvasClearSort()"></button>
    </div>
    <div class="offcanvas-body">
      <div class="sort-container">
        <div *ngFor="let item of sortDirList ;trackBy: trackByIndex">
          <label class="d-flex sort-contain">
            <input class="sort-input" type="radio" name="sortDirMobile" [(ngModel)]="model.sortDir"
                   [value]="item.uniqueKey">
            <span>{{ item.displayName }}</span>
          </label>
        </div>
      </div>
      <div class="d-flex justify-content-between">
        <button data-bs-dismiss="offcanvas" aria-label="Close" (click)="submitSort()"
                class="btn btn-primary filter-sort-btn" type="submit">
          <span class="icon-sort sort-icon"></span>
          <span class="sort-text">{{translationData.sort || "Sort"}}</span>
        </button>
        <button data-bs-dismiss="offcanvas" aria-label="Close" (click)="clearSort()" class="btn clear-btn"
                type="button">{{ translationData?.clearSort || "clear Sort" }}</button>
      </div>
    </div>
  </div>
        </div>
      </form>
    </div>

  </div>
  <div class="services-listing">
    <div class="service-catalog">
      <div>
        <h2 class="home-title title-res">
          {{ translationData.serviceCatalog || "Service Catolgue" }}
        </h2>
      </div>
    </div>
    <div class="form-row">

      <!-- start of card component -->
      <div *ngFor="let service of serviceList ;trackBy: trackByIndex" class="col-md-6 col-sm-12 d-flex card-service-respons">
        <div class="service-catalog-card flex-grow-1 ">
          <div class="service-card  text-decoration-none" title="">
            <div class="d-flex res-resize ">
              <div class="service-img">
                <a  aria-label="service Details Route" title="service Details Route"
                href="{{ baseURL? baseURL +'/'+ serviceDetailsRoute + service.id : serviceDetailsRoute + '/' + service.id }}"
                  class="text-decoration-none"><img loading="lazy" *ngIf="!service.image" src="../../assets/images/service-catalog.svg"
                  [alt]="service.serviceName" /><img loading="lazy" *ngIf="service.image" [src]="getImageSrc(service.image)"
                  [alt]="service.serviceName" /></a>
              </div>
              <div class="service-body rounded ">

                <h3 [title]="service.serviceName" class="service-title">
                  <a aria-label="service Details Route" [title]="service.serviceName"
                  href="{{ baseURL? baseURL +'/'+ serviceDetailsRoute + service.id : serviceDetailsRoute + '/' + service.id }}"
                    class="text-decoration-none"> {{ service.serviceName }}</a>
                </h3>
                <a aria-label="service Details Route" [title]="stripHtml(service.description)"
                 href="{{ baseURL? baseURL +'/'+ serviceDetailsRoute + service.id : serviceDetailsRoute + '/' + service.id }}"
                  class="service-brief text-decoration-none" [innerHTML]="service.description | safe: 'html'"></a>
              </div>
            </div>
            <div class="sharer-container">
              <div class="sharer position-relative">
                <button class="sharer-btn p-0 border-0 position-relative" type="button" role="button"
                  [title]="translationData.share" >
                  <span class="icon-share">
                  </span>
                </button>
                <div class="sharer-links position-absolute">
                  <ul class="list-unstyled d-flex justify-content-center align-items-center h-100">
                    <li>
                      <a href="https://www.facebook.com/sharer/sharer.php?u={{baseuRL+'/%23/services/service-details/' + service.id}}&amp;src=sdkpreparse"
                        class="d-flex align-items-center" target="_blank" [title]="translationData.facebook" >
                        <span class="icon-facebook icon-social"></span>
                      </a>
                    </li>
                    <li>
                      <a href="http://twitter.com/share?text=&url={{baseuRL+'/%23/services/service-details/' + service.id}}&hashtags"
                        class="d-flex align-items-center" target="_blank" [title]="translationData.twitter" >
                        <span class="icon-twitter icon-social"></span>
                      </a>
                    </li>
                    <li>
                      <a href="https://www.linkedin.com/sharing/share-offsite/?url={{baseuRL+'/%23/services/service-details/' + service.id}}"
                        class="d-flex align-items-center" target="_blank" [title]="translationData.linkedin" >
                        <span class="icon-linkedin-2 icon-social"></span>
                      </a>
                    </li>
                    <li>
                      <a href="https://wa.me/?text={{baseuRL+'/%23/services/service-details/' + service.id}}"
                        data-action="share/whatsapp/share" class="d-flex align-items-center" target="_blank"
                        [title]="translationData.whatsapp" >
                        <span class="icon-whatsapp icon-social"></span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>



          </div>
        </div>

      </div>
      <!-- end of card component -->

    </div>
    <a aria-label="service Cards Route" title="service Cards Route" href="{{ baseURL? baseURL+serviceCardsRoute : serviceCardsRoute }}" *ngIf="isHomepage && totalCount > pageSize"
      class="btn btn-primary mx-auto my-4  d-table view-btn">
      {{ translationData?.viewAll || "View all" }}
    </a>
    <div *ngIf="serviceList && serviceList.length == 0" class="no-results-msg">
      <p><span class="icon-search"></span></p>
      <p>{{ translationData?.noResultMsg || "No Results Found" }}</p>
    </div>
    <div class="row">
      <lib-pager [first]="start" *ngIf="!isHomepage && totalCount > pageSize" class="my-5 d-block m-auto py-3"
        (pageChange)="pageChange($event)" pageLinkSize="5" [rows]="pageSize" [totalRecords]="totalCount">
      </lib-pager>
    </div>
  </div>



</section>
